import { render, staticRenderFns } from "./CardExtensao.vue?vue&type=template&id=2a17e9ae&"
import script from "./CardExtensao.vue?vue&type=script&lang=js&"
export * from "./CardExtensao.vue?vue&type=script&lang=js&"
import style0 from "./CardExtensao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports